var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4744_98090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.45825 14.709L10.9999 18.9798L19.5416 14.709M2.45825 10.4382L10.9999 14.709L19.5416 10.4382M10.9999 1.89648L2.45825 6.16732L10.9999 10.4382L19.5416 6.16732L10.9999 1.89648Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4744_98090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 20.5,
    fill: "white",
    transform: "translate(0.75 0.1875)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOrders);
export default __webpack_public_path__ + "static/media/menu-orders.fe4e2b93d78f42c437f229fd70450ea8.svg";
export { ForwardRef as ReactComponent };